formatWithLocale